import React, { useState, useEffect, useContext } from "react";
import {
  PencilSquareIcon,
  Square3Stack3DIcon,
  ArrowLongLeftIcon,
  ArrowLongRightIcon,
} from "@heroicons/react/24/outline";
import axios from "axios";
import { saveAs } from "file-saver";
import { AppContext } from "../context/AppContext";
import ReCAPTCHA from "react-google-recaptcha";
import Cookies from "js-cookie";

const TawkilRequests = () => {
  const { siteKey } = useContext(AppContext);
  const [Selection, setSelection] = useState(0);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    nationalId: "",
    userNationalId: "",
    phoneNumber: "",
    address: "",
    zipCode: "",
    secondaryAddress: "",
  });
  const [EditData, setEditData] = useState({
    firstName: "",
    lastName: "",
    nationalId: "",
    userNationalId: "",
    phoneNumber: "",
    address: "",
    zipCode: "",
    secondaryAddress: "",
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentTawkils, setCurrentTawkils] = useState([]);
  const [totalTawkilPages, setTotalTawkilPages] = useState(0);
  const [SelectedTawkilId, setSelectedTawkilId] = useState(null);
  const [captchaValue, setcaptchaValue] = useState(null);
  const [loading, setLoading] = useState(false);

  const tabs = [
    { name: "Submit tawkil", icon: PencilSquareIcon },
    { name: "Your Tawkils", icon: Square3Stack3DIcon },
  ];

  const toggleSelectedTab = (index) => {
    setSelection(index);
  };

  const handleTawKilChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const handleEditedChange = (e) => {
    const { name, value } = e.target;
    setEditData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Set loading state to true
    // Validation checks
    const newErrors = {};
    // First name and last name validation
    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
    }
    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }

    // National ID, partner national ID, and phone number validation
    const numericRegex = /^[0-9]+$/;
    if (
      !formData.nationalId.trim() ||
      !numericRegex.test(formData.nationalId) ||
      formData.nationalId.length !== 8
    ) {
      newErrors.nationalId = "National ID must be 8-digit numeric value";
    }
    if (
      !formData.userNationalId.trim() ||
      !numericRegex.test(formData.userNationalId) ||
      formData.userNationalId.length !== 8
    ) {
      newErrors.userNationalId =
        "Partner National ID must be 8-digit numeric value";
    }
    if (
      !formData.phoneNumber.trim() ||
      !numericRegex.test(formData.phoneNumber) ||
      formData.phoneNumber.length !== 8
    ) {
      newErrors.phoneNumber = "Phone number must be 8-digit numeric value";
    }

    // Zip code validation
    if (!formData.zipCode.trim() || !numericRegex.test(formData.zipCode)) {
      newErrors.zipCode = "Zip code must be a numeric value";
    }

    // Address and secondary address validation
    if (!formData.address.trim()) {
      newErrors.address = "Address is required";
    }
    if (!formData.secondaryAddress.trim()) {
      newErrors.secondaryAddress = "Secondary address is required";
    }

    // If there are errors, set them in state or handle them accordingly
    if (Object.keys(newErrors).length !== 0) {
      setErrors(newErrors);
      console.log("Validation errors:", newErrors);
      setLoading(false); // Set loading state to false
    } else {
      try {
        const token = Cookies.get("token");
        const user = JSON.parse(Cookies.get("user"));

        const tawkilData = new FormData();

        // Append form data
        Object.entries(formData).forEach(([key, value]) => {
          tawkilData.append(key, value);
        });

        const response = await axios.post(
          `${process.env.REACT_APP_ADDRESS}/tawkil/tawkil-request/${user._id}`,
          tawkilData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        console.log(response.data);
        setFormData({
          firstName: "",
          lastName: "",
          nationalId: "",
          userNationalId: "",
          phoneNumber: "",
          address: "",
          zipCode: "",
          secondaryAddress: "",
        });

        setSuccessMessage("Item submitted successfully!");
        fetchTawkils();

        setSuccessMessage("");
      } catch (error) {
        console.error("Error:", error);
      }
      setLoading(false); // Set loading state to false
    }
  };

  const fetchTawkils = async () => {
    try {
      const token = Cookies.get("token");
      const user = JSON.parse(Cookies.get("user"));

      const response = await axios.get(
        `${process.env.REACT_APP_ADDRESS}/tawkil/tawkil-request/user/${user._id}?search=${searchTerm}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setCurrentTawkils(response.data);
      setTotalTawkilPages(Math.ceil(response.data.length / 5));
    } catch (error) {
      console.error("Error fetching tawkils:", error);
    }
  };

  useEffect(() => {
    if (searchTerm.length === 0 || searchTerm.length > 2) fetchTawkils();
  }, [searchTerm]);

  const nextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalTawkilPages));
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const token = Cookies.get("token");
      const response = await axios.put(
        `${process.env.REACT_APP_ADDRESS}/tawkil/tawkil-request/${SelectedTawkilId}`,
        EditData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log(response.data);
      setSuccessMessage("Item Edited successfully!");
      handleEdit(SelectedTawkilId);

      fetchTawkils();
    } catch (error) {
      console.error("Error:", error);

      if (error.response) {
        setErrors(error.response.data);
      }
    } 
     finally {
   setSelectedTawkilId(null);
    }
  };

  const handleDownload = (tawkilData) => {
    const user = JSON.parse(Cookies.get("user"));
    createAndDownloadPdf({ tawkilData, user });
    alert("Downloading tawkil PDF file...");
  };

  const handleDelete = async (tawkilId) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      try {
        const token = Cookies.get("token");
        const response = await axios.delete(
          `${process.env.REACT_APP_ADDRESS}/tawkil/tawkil-request/${tawkilId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log(response.data);

        if (response.status === 200) {
          setSuccessMessage("Item deleted successfully!");
          fetchTawkils();

          setSuccessMessage("");
        } else {
          console.log(
            "Item not disabled or response status is not 200:",
            tawkilId
          );
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const handleEdit = async (tawkilId) => {
    setSelectedTawkilId(tawkilId);
    try {
      const token = Cookies.get("token");
      const response = await axios.get(
        `${process.env.REACT_APP_ADDRESS}/tawkil-request/${tawkilId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const tawkilData = response.data;
      setEditData({
        firstName: tawkilData.firstName,
        lastName: tawkilData.lastName,
        nationalId: tawkilData.nationalId,
        userNationalId: tawkilData.userNationalId,
        phoneNumber: tawkilData.phoneNumber,
        address: tawkilData.address,
        zipCode: tawkilData.zipCode,
        secondaryAddress: tawkilData.secondaryAddress,
      });
    } catch (error) {
      console.error("Error fetching tawkil data:", error);
    }
  };

  const createAndDownloadPdf = async (data) => {
    const token = Cookies.get("token");
    console.log("data in ceate pdf " + data);
    const postheaders = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .post(
        `${process.env.REACT_APP_ADDRESS}/tawkil/TawkilPdf-creation`,
        data,
        postheaders
      )

      .then(() =>
        axios.get(`${process.env.REACT_APP_ADDRESS}/tawkil/fetch-Tawkil-pdf`, {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      )
      .then((res) => {
        console.log(JSON.stringify(res));
        const pdfBlob = new Blob(
          [res.data],
          { type: "application/pdf" },
          postheaders
        );
        saveAs(pdfBlob, "generatedDocument.pdf");
      })
      .catch((error) => {
        console.error("Error creating or downloading PDF:", error);
      });
  };

  return (
    <>
      <div className="p-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">
          Tawkil Service
        </h1>
        <div className="bg-white shadow-lg rounded-lg p-8 mb-10">
          <h2 className="text-2xl font-semibold text-pink-600 mb-4">
            What It Is:
          </h2>
          <p className="text-gray-700 mb-6">
            Streamline your wedding planning with our convenient online tawkil
            service! Tawkil allows you to designate a trusted representative to
            handle marriage-related administrative tasks on your behalf. This
            frees you and your partner to focus on the exciting parts of wedding
            preparation, while your representatives efficiently collect legal
            documents and handle administrative burdens at various government
            offices. With tawkil, you can devote your energy to creating your
            dream wedding, all while ensuring a smooth and stress-free legal
            process.
          </p>
          <h2 className="text-2xl font-semibold text-pink-600 mb-4">
            How to Initiate the Tawkil:
          </h2>
          <p className="text-gray-700 mb-4">
            <strong>Partner Information:</strong> The partner initiating the
            online tawkil will enter their details first, including: (First
            Name, Last Name, National ID Number, Partner&apos;s National ID
            Number, Phone Number, Full Street Address, Zip Code)
          </p>
          <p className="text-gray-700 mb-4">
            <strong>Trusted Representative:</strong> Next, you&apos;ll provide
            details for your chosen representative, including all the
            information listed in Step 1 (First Name, Last Name, National ID,
            etc.).
          </p>
          <p className="text-gray-700 mb-6">
            To ensure legal validity, this online tawkil will require
            finalization through one of the following options:
          </p>
          <ul className="list-disc pl-5 text-gray-700 space-y-2 mb-6">
            <li>
              <strong>Notarization:</strong> You can visit a local notary public
              with your representative to have the tawkil officially stamped and
              signed. This adds an extra layer of legal verification.
            </li>
            <li>
              <strong>Municipal Finalization:</strong> Visit your local
              municipality office together. There, officials can verify your
              identities and finalize the tawkil agreement.
            </li>
            <li>
              <strong>E-signature (Coming Soon!):</strong> In the near future,
              our service will offer a convenient e-signature option for both
              parties. This will eliminate the need for physical visits and
              further streamline the process.
            </li>
          </ul>
          <h2 className="text-2xl font-semibold text-pink-600 mb-4">
            Why You Need It:
          </h2>
          <ul className="list-disc pl-5 text-gray-700 space-y-2">
            <li>
              <strong>Delegation of Responsibilities:</strong> Save time and
              effort by delegating legal tasks to a trusted representative.
            </li>
            <li>
              <strong>Efficiency:</strong> Streamline the process of handling
              legal documentation and administrative tasks.
            </li>
            <li>
              <strong>Convenience:</strong> Manage legal requirements without
              the need for constant personal involvement.
            </li>
          </ul>
        </div>
      </div>
      <div>
        <div>
          <div className="hidden sm:block">
            <div className="border-b border-gray-200">
              <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                {tabs.map((tab, index) => (
                  <button
                    key={tab.name}
                    className={`${
                      Selection === index
                        ? "border-pink-500 text-pink-600"
                        : "border-transparent text-gray-500 hover:border-pink-300 hover:text-pink-600"
                    } group inline-flex items-center border-b-2 py-4 px-1 text-sm font-medium`}
                    onClick={() => toggleSelectedTab(index)}
                  >
                    {tab.icon && (
                      <tab.icon
                        className={`${
                          Selection === index
                            ? "text-pink-500"
                            : "text-gray-400 group-hover:text-pink-500"
                        } -ml-0.5 mr-2 h-5 w-5`}
                        aria-hidden="true"
                      />
                    )}
                    <span>{tab.name}</span>
                  </button>
                ))}
              </nav>
            </div>
          </div>
        </div>
        {successMessage && (
          <div className="text-green-600">{successMessage}</div>
        )}
        {Selection === 0 && (
          <>
            {loading ? (
              <div role="status" className="flex justify-center mt-12">
                <svg
                  aria-hidden="true"
                  className="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-pink-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span className="sr-only">Loading...</span>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="space-y-12 sm:space-y-16">
                  <div>
                    <h2 className="pt-5 text-base font-semibold leading-7 text-gray-900">
                      Enter Tawkil Informations :{" "}
                    </h2>

                    <div className="mt-10 space-y-8 border-b border-gray-900/10 pb-12 sm:space-y-0 sm:divide-y sm:divide-gray-900/10 sm:border-t sm:pb-0">
                      <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
                        <label className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                          First name
                        </label>
                        <div className="mt-2 sm:col-span-2 sm:mt-0">
                          <input
                            type="text"
                            name="firstName"
                            id="firstName"
                            autoComplete="given-name"
                            value={formData.firstName}
                            onChange={handleTawKilChange}
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:max-w-xs sm:text-sm sm:leading-6"
                          />
                          {errors.firstName && (
                            <span className="text-red-500">
                              {errors.firstName}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
                        <label className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                          Last name
                        </label>
                        <div className="mt-2 sm:col-span-2 sm:mt-0">
                          <input
                            type="text"
                            name="lastName"
                            id="lastName"
                            autoComplete="family-name"
                            value={formData.lastName}
                            onChange={handleTawKilChange}
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:max-w-xs sm:text-sm sm:leading-6 "
                          />
                          {errors.lastName && (
                            <span className="text-red-500">
                              {errors.lastName}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
                        <label className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                          National ID
                        </label>
                        <div className="mt-2 sm:col-span-2 sm:mt-0">
                          <input
                            name="nationalId"
                            id="nationalId"
                            autoComplete="nationalId"
                            value={formData.nationalId}
                            onChange={handleTawKilChange}
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:max-w-md sm:text-sm sm:leading-6"
                          />
                          {errors.nationalId && (
                            <span className="text-red-500">
                              {errors.nationalId}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
                        <label className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                          Partner National ID
                        </label>
                        <div className="mt-2 sm:col-span-2 sm:mt-0">
                          <input
                            name="userNationalId"
                            id="userNationalId"
                            autoComplete="userNationalId"
                            value={formData.userNationalId}
                            onChange={handleTawKilChange}
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:max-w-md sm:text-sm sm:leading-6"
                          />
                          {errors.userNationalId && (
                            <span className="text-red-500">
                              {errors.userNationalId}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
                        <label className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                          Phone Number
                        </label>
                        <div className="mt-2 sm:col-span-2 sm:mt-0">
                          <input
                            name="phoneNumber"
                            id="phoneNumber"
                            autoComplete="phoneNumber"
                            value={formData.phoneNumber}
                            onChange={handleTawKilChange}
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:max-w-xs sm:text-sm sm:leading-6"
                          />
                          {errors.phoneNumber && (
                            <span className="text-red-500">
                              {errors.phoneNumber}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
                        <label className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                          Street address
                        </label>
                        <div className="mt-2 sm:col-span-2 sm:mt-0">
                          <input
                            type="text"
                            name="address"
                            id="address"
                            value={formData.address}
                            onChange={handleTawKilChange}
                            autoComplete="address"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:max-w-xl sm:text-sm sm:leading-6"
                          />
                          {errors.address && (
                            <span className="text-red-500">
                              {errors.address}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
                        <label className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                          Zip Code
                        </label>
                        <div className="mt-2 sm:col-span-2 sm:mt-0">
                          <input
                            type="text"
                            name="zipCode"
                            id="szipCode"
                            value={formData.zipCode}
                            onChange={handleTawKilChange}
                            autoComplete="zipCode"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:max-w-xl sm:text-sm sm:leading-6"
                          />
                          {errors.zipCode && (
                            <span className="text-red-500">
                              {errors.zipCode}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
                        <label className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                          Secondary adress
                        </label>
                        <div className="mt-2 sm:col-span-2 sm:mt-0">
                          <input
                            type="text"
                            name="secondaryAddress"
                            id="ssecondaryAddress"
                            value={formData.secondaryAddress}
                            onChange={handleTawKilChange}
                            autoComplete="secondaryAddress"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:max-w-xl sm:text-sm sm:leading-6"
                          />
                          {errors.secondaryAddress && (
                            <span className="text-red-500">
                              {errors.secondaryAddress}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    paddingTop: "8px",
                  }}
                >
                  <button
                    type="submit"
                    disabled={!captchaValue}
                    style={{
                      backgroundColor: "#d53f8c",
                      color: "white",
                      border: "none",
                      padding: "8px 16px",
                      borderRadius: "4px",
                      margin: "4px",
                    }}
                  >
                    Submit
                  </button>
                </div>
                <div>
                  <ReCAPTCHA
                    sitekey={siteKey}
                    onChange={(val) => setcaptchaValue(val)}
                  />
                </div>
              </form>
            )}
          </>
        )}
        {Selection === 1 && (
          <div className="flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                <div className="search-container w-1/4 float-right">
                  <div className="relative">
                    <input
                      type="search"
                      className="relative m-0 block w-full rounded border border-solid border-neutral-200 bg-transparent bg-clip-padding px-3 py-[0.25rem] text-base font-normal leading-[1.6] text-surface outline-none transition duration-200 ease-in-out placeholder:text-neutral-500 focus:border-pink focus:shadow-inset focus:outline-none motion-reduce:transition-none dark:border-white/10 text-black dark:placeholder:text-neutral-200 dark:autofill:shadow-autofill"
                      placeholder="Search tawkils by name..."
                      onChange={(event) => {
                        setSearchTerm(event.target.value);
                      }}
                    />
                  </div>
                </div>
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                      >
                        National ID
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-gray-200">
                    {currentTawkils.map((tawkil) => (
                      <>
                        {tawkil.isDisabled === false && (
                          <tr key={tawkil._id}>
                            <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                              {tawkil.firstName} {tawkil.lastName}
                            </td>
                            <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                              {tawkil.nationalId}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                              {SelectedTawkilId === tawkil._id ? (
                                <form
                                  onSubmit={(e) => handleSave(e, tawkil._id)}
                                >
                                  <div className="space-y-12 sm:space-y-16">
                                    <div>
                                      <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">

                                        <div className="sm:col-span-3">
                                          <label
                                            htmlFor="firstName"
                                            className="block text-sm font-medium leading-6 text-gray-900"
                                          >
                                            First name
                                          </label>
                                          <div className="mt-2">
                                            <input
                                              type="text"
                                              name="firstName"
                                              id="firstName"
                                              autoComplete="given-name"
                                              value={EditData.firstName}
                                              onChange={handleEditedChange}
                                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                                            />
                                            {errors.firstName && (
                                              <span className="text-red-500">
                                                {errors.firstName}
                                              </span>
                                            )}
                                          </div>
                                        </div>

                                        <div className="sm:col-span-3">
                                          <label
                                            htmlFor="lastName"
                                            className="block text-sm font-medium leading-6 text-gray-900"
                                          >
                                            Last name
                                          </label>
                                          <div className="mt-2">
                                            <input
                                              type="text"
                                              name="lastName"
                                              id="lastName"
                                              autoComplete="family-name"
                                              value={EditData.lastName}
                                              onChange={handleEditedChange}
                                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6 "
                                            />
                                            {errors.lastName && (
                                              <span className="text-red-500">
                                                {errors.lastName}
                                              </span>
                                            )}
                                          </div>
                                        </div>

                                        <div className="sm:col-span-2 sm:col-start-1">
                                          <label
                                            htmlFor="nationalId"
                                            className="block text-sm font-medium leading-6 text-gray-900"
                                          >
                                            National ID
                                          </label>
                                          <div className="mt-2">
                                            <input
                                              type="text"
                                              name="nationalId"
                                              id="nationalId"
                                              autoComplete="nationalId"
                                              value={EditData.nationalId}
                                              onChange={handleEditedChange}
                                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                                            />
                                            {errors.nationalId && (
                                              <span className="text-red-500">
                                                {errors.nationalId}
                                              </span>
                                            )}
                                          </div>
                                        </div>

                                        <div className="sm:col-span-2">
                                          <label
                                            htmlFor="userNationalId"
                                            className="block text-sm font-medium leading-6 text-gray-900"
                                          >
                                            User National ID
                                          </label>
                                          <div className="mt-2">
                                            <input
                                              type="text"
                                              name="userNationalId"
                                              id="userNationalId"
                                              autoComplete="userNationalId"
                                              value={EditData.userNationalId}
                                              onChange={handleEditedChange}
                                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                                            />
                                            {errors.userNationalId && (
                                              <span className="text-red-500">
                                                {errors.userNationalId}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                        <div className="sm:col-span-2">
                                          <label
                                            htmlFor="phoneNumber"
                                            className="block text-sm font-medium leading-6 text-gray-900"
                                          >
                                            Phone Number
                                          </label>
                                          <div className="mt-2">
                                            <input
                                              type="text"
                                              name="phoneNumber"
                                              id="phoneNumber"
                                              autoComplete="phoneNumber"
                                              value={EditData.phoneNumber}
                                              onChange={handleEditedChange}
                                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                                            />
                                            {errors.phoneNumber && (
                                              <span className="text-red-500">
                                                {errors.phoneNumber}
                                              </span>
                                            )}
                                          </div>
                                        </div>

                                        <div className="sm:col-span-2 sm:col-start-1">
                                          <label
                                            htmlFor="address"
                                            className="block text-sm font-medium leading-6 text-gray-900"
                                          >
                                            Address
                                          </label>
                                          <div className="mt-2">
                                            <input
                                              type="text"
                                              name="address"
                                              id="address"
                                              autoComplete="address-level2"
                                              value={EditData.address}
                                              onChange={handleEditedChange}
                                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                                            />
                                            {errors.address && (
                                              <span className="text-red-500">
                                                {errors.address}
                                              </span>
                                            )}
                                          </div>
                                        </div>

                                        <div className="sm:col-span-2">
                                          <label
                                            htmlFor="secondaryAddress"
                                            className="block text-sm font-medium leading-6 text-gray-900"
                                          >
                                            State / Province
                                          </label>
                                          <div className="mt-2">
                                            <input
                                              type="text"
                                              name="secondaryAddress"
                                              id="secondaryAddress"
                                              autoComplete="address-level1"
                                              value={EditData.secondaryAddress}
                                              onChange={handleEditedChange}
                                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                                            />
                                            {errors.secondaryAddress && (
                                              <span className="text-red-500">
                                                {errors.secondaryAddress}
                                              </span>
                                            )}
                                          </div>
                                        </div>

                                        <div className="sm:col-span-2">
                                          <label
                                            htmlFor="zipCode"
                                            className="block text-sm font-medium leading-6 text-gray-900"
                                          >
                                            ZIP / Postal code
                                          </label>
                                          <div className="mt-2">
                                            <input
                                              type="text"
                                              name="zipCode"
                                              id="zipCode"
                                              autoComplete="zipCode"
                                              value={EditData.zipCode}
                                              onChange={handleEditedChange}
                                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                                            />
                                            {errors.zipCode && (
                                              <span className="text-red-500">
                                                {errors.zipCode}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div style={{ paddingTop: "4px " }}>
                                    <button
                                      disabled={!captchaValue}
                                      type="submit"
                                      style={{
                                        backgroundColor: "#d53f8c",
                                        color: "white",
                                        border: "none",
                                        padding: "8px 16px",
                                        borderRadius: "4px",
                                        margin: "4px",
                                      }}
                                    >
                                      submit
                                    </button>
                                    <button
                                      onClick={() => setSelectedTawkilId(null)}
                                      style={{
                                        backgroundColor: "#D3C5C2",
                                        color: "white",
                                        border: "none",
                                        padding: "8px 16px",
                                        borderRadius: "4px",
                                        margin: "4px",
                                      }}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </form>
                              ) : (
                                <>
                                  <button
                                    onClick={() => handleEdit(tawkil._id)}
                                    style={{
                                      backgroundColor: "#d53f8c",
                                      color: "white",
                                      border: "none",
                                      padding: "8px 16px",
                                      borderRadius: "4px",
                                      margin: "4px",
                                    }}
                                  >
                                    Edit
                                  </button>
                                  <button
                                    onClick={() => handleDelete(tawkil._id)}
                                    style={{
                                      backgroundColor: "#ff3333",
                                      color: "white",
                                      border: "none",
                                      padding: "8px 16px",
                                      borderRadius: "4px",
                                      margin: "4px",
                                    }}
                                  >
                                    Delete
                                  </button>
                                  <button
                                    onClick={() => handleDownload(tawkil)}
                                    style={{
                                      backgroundColor: "#00cc44",
                                      color: "white",
                                      border: "none",
                                      padding: "8px 16px",
                                      borderRadius: "4px",
                                      margin: "4px",
                                    }}
                                  >
                                    Download
                                  </button>
                                </>
                              )}
                            </td>
                          </tr>
                        )}
                      </>
                    ))}
                  </tbody>
                </table>

                <nav className="flex items-center justify-between border-t border-gray-200 px-4 sm:px-0">
                  <div className="-mt-px flex w-0 flex-1">
                    <button
                      onClick={prevPage}
                      disabled={currentPage === 1}
                      className={`inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium ${
                        currentPage === 1
                          ? "text-gray-300 pointer-events-none"
                          : "text-gray-500 hover:border-gray-300 hover:text-gray-700"
                      }`}
                    >
                      <ArrowLongLeftIcon
                        className="mr-3 h-5 w-5 text-gray-400"
                        aria-hidden="true"
                      />
                      Previous
                    </button>
                  </div>
                  <div className="hidden md:-mt-px md:flex">
                    {Array.from({ length: totalTawkilPages }).map(
                      (_, index) => (
                        <a
                          key={index + 1}
                          href="#"
                          onClick={() => setCurrentPage(index + 1)}
                          className={`inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium ${
                            currentPage === index + 1
                              ? "border-pink-500 text-pink-600"
                              : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                          }`}
                        >
                          {index + 1}
                        </a>
                      )
                    )}
                  </div>
                  <div className="-mt-px flex w-0 flex-1 justify-end">
                    <button
                      onClick={nextPage}
                      disabled={currentPage === totalTawkilPages}
                      className={`inline-flex items-center border-t-2 border-transparent pl-1 pt-4 text-sm font-medium ${
                        currentPage === totalTawkilPages
                          ? "text-gray-300 pointer-events-none"
                          : "text-gray-500 hover:border-gray-300 hover:text-gray-700"
                      }`}
                    >
                      Next
                      <ArrowLongRightIcon
                        className="ml-3 h-5 w-5 text-gray-400"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default TawkilRequests;
